import React, { FC, FunctionComponent, Suspense } from 'react';
//import { closeDialogAction } from "./helpers"
import MdClose from 'src/shared/icons/times-solid.svg';
import styled from 'styled-components';

export const dialogContext = React.createContext({ dialogId: '' });

export const DialogContent = styled.div`
    overflow: auto;
    flex: 1;
`;

export const DialogWindowContainer = styled.div`
    padding: 20px;
    padding-top: 20px;
    background-color: white;
    border-radius: 10px;
    width: 100%;
    max-width: 450px;
    max-height: 234px;
    flex: 1;
    display: flex;
    position: relative;
`;

export const DialogWindowClose = styled(MdClose)`
    position: absolute;
    right: 10px;
    top: 10px;
    cursor: pointer;
    width: 20px;
    height: 20px;
    z-index: 999;

    &:hover {
        opacity: 0.5;
    }
`;

interface DialogWindowProps {
    className?: string;
    onClose: () => void;
    children?: React.ReactNode;
}

export const DialogWindow: FC<DialogWindowProps> = (props) => {
    return (
        <DialogWindowContainer className={props.className}>
            <DialogWindowClose onClick={props.onClose} />
            {props.children}
        </DialogWindowContainer>
    );
};

export const DialogOverlay = styled.div`
    position: fixed;
    background-color: rgba(0, 0, 0, 0.7);
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 70px 40px;
    overflow: auto;
`;

interface DialogProps {
    onClose: () => void;
    children?: React.ReactNode;
}

export const Dialog: FunctionComponent<DialogProps> = (props) => {
    const onClose = props.onClose;

    return (
        <DialogOverlay>
            <DialogWindow onClose={onClose}>
                <DialogContent>
                    <Suspense fallback={'Loading...'}>{props.children}</Suspense>
                </DialogContent>
            </DialogWindow>
        </DialogOverlay>
    );
};
